import styled from '@emotion/styled';

export const Action = styled.div<{
    readonly $surface?: 'integrated' | 'standalone';
}>(({ $surface, theme }) => ({
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: $surface === 'integrated' ? 'transparent' : theme.colors.gray[100],
    borderRadius: $surface === 'integrated' ? 0 : theme.borderRadius.xl,
    boxShadow: $surface === 'integrated' ? 'none' : theme.shadows.small,
    containerName: 'action',
    containerType: 'inline-size',
    display: $surface === 'integrated' ? 'grid' : 'flex',
    flexDirection: $surface === 'integrated' ? undefined : 'row',
    gap: theme.spacing.l,
    gridTemplateColumns: $surface === 'integrated' ? 'max-content max-content minmax(0, 1fr)' : undefined,
    justifyContent: $surface === 'integrated' ? 'stretch' : 'space-between',
    padding: $surface === 'integrated' ? 0 : `${theme.spacing.xxs}`,
}));

export const CTAWrapper = styled.div(({ theme }) => ({
    alignItems: 'center',
    button: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
    gap: theme.spacing.xs,
    justifyContent: 'flex-end',
    justifySelf: 'end',
    minWidth: 0,
    paddingRight: 0,
}));

export const ActionSeparator = styled.div(({ theme }) => ({
    alignSelf: 'center',
    backgroundColor: theme.colors.gray[400],
    display: 'block',
    height: theme.spacing.xxl,
    width: '1px',
}));
